import TabWazzup from './TabWazzup';

export default TabWazzup;
